import axios from "axios";
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import {
    Visibility,
    Edit,
    Cancel,
    FilterList,
    Search,
} from "@mui/icons-material";
import {
    Table,
    Button,
    Form,
    InputGroup,
    Row,
    Col,
    Badge,
} from "react-bootstrap";
import DataTable from "../../../components/Table/DataTable";
import SearchFilterBar from "../../../components/Table/SearchFilterBar";
import PaginationControl from "../../../components/Table/PaginationControl";
import "./Order.css";

const Order = () => {
    const [orders, setOrders] = useState([]);
    const [search, setSearch] = useState("");
    const [statusFilter, setStatusFilter] = useState("All");
    const [page, setPage] = useState(1);
    const perPage = 5;

    // useEffect(() => {
    //     const mockOrders = [
    //         {
    //             id: "ORD001",
    //             OrderId: "ORD001",
    //             customer: "John Doe",
    //             date: "2025-10-01",
    //             total: "AED 120.00",
    //             status: "Pending",
    //         },
    //         {
    //             id: "ORD002",
    //             OrderId: "ORD002",
    //             customer: "Jane Smith",
    //             date: "2025-10-03",
    //             total: "",
    //             status: "Completed",
    //         },
    //         {
    //             id: "ORD003",
    //             OrderId: "ORD003",
    //             customer: "Mark Wilson",
    //             date: "2025-10-05",
    //             total: "AED 80.00",
    //             status: "Cancelled",
    //         },
    //     ];
    //     setOrders(mockOrders);
    // }, []);
    useEffect(() => {
        fetchOrders();
    }, []);

    const fetchOrders = async () => {
        try {
            const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/admin/orders/get`,
                {
                    withCredentials: true,
                }
            );
            console.log(data.orders);

            setOrders(data.orders);
        } catch (error) {
            console.log(error);
        }
    };

    const filtered = orders.filter(
        (order) =>
            order.customerName
                ?.toLowerCase()
                .includes(search.toLowerCase()) &&
            (statusFilter === "All" ||
                order.status === statusFilter)
    );

    const totalPages = Math.ceil(filtered.length / perPage);
    const paginated = filtered.slice((page - 1) * perPage, page * perPage);

    const columns = [
        "Order No",
        "Customer Details",
        "Items",
        "Date",
        // "Status"
    ];

    const renderRow = (order) => (
        <tr key={order._id}>
            <td>
                <strong>{order.orderNumber}</strong>
            </td>

            <td>
                <div>
                    <strong>{order.customerName}</strong>
                </div>

                <div>{order.customerEmail}</div>

                <div>{order.customerPhone}</div>

                <div className="text-muted small">
                    {order.shippingAddress}
                </div>
            </td>

            <td>
                {order.items?.map((item) => (
                    <div
                        key={item._id || item.productId}
                        className="d-flex align-items-center mb-2"
                    >
                        <img
                            src={item.image}
                            alt={item.productName}
                            width={50}
                            height={50}
                            style={{
                                objectFit: "cover",
                                borderRadius: "6px",
                                marginRight: "10px",
                                border: "1px solid #eee",
                            }}
                        />

                        <div>
                            <div className="fw-semibold">
                                {item.productName}
                            </div>

                            <small className="text-muted">
                                Qty: {item.qty}
                            </small>

                            <br />

                            <small>
                                AED {item.price}
                            </small>
                        </div>
                    </div>
                ))}
            </td>

            <td>
                {new Date(order.createdAt).toLocaleDateString()}
            </td>

            {/* <td>
                <Badge
                    bg={
                        order.status === "Delivered"
                            ? "success"
                            : order.status === "Pending"
                                ? "warning"
                                : order.status === "Cancelled"
                                    ? "danger"
                                    : "primary"
                    }
                >
                    {order.status}
                </Badge>
            </td> */}
        </tr>
    );

    return (
        <div className="container-fluid p-3">
            <h4 className="fw-bold mb-4">Orders Management</h4>

            <SearchFilterBar
                searchTerm={search}
                setSearchTerm={setSearch}
                filterValue={statusFilter}
                setFilterValue={setStatusFilter}
                filterOptions={[
                    "Pending",
                    "Confirmed",
                    "Shipped",
                    "Delivered",
                    "Cancelled",
                ]}
                placeholder="Search customer..."
            />

            <DataTable columns={columns} data={paginated} renderRow={renderRow} />
            <PaginationControl totalPages={totalPages} currentPage={page} onPageChange={setPage} />
        </div>
    );
};

export default Order;
